export default function Footer() {
  return (
    <div className="text-center bg-tertiary py-4">
      Copyright © John Doomy 2026 - v1.2.4
    </div>
  );
}
